import styles from "./PhotoItem.module.css";

export default function PhotoItem(props) {
  const { id, title, imgPath, onClickHandler } = props;

  return (
    <div
      onClick={() => {
        onClickHandler(id);
      }}
      className={styles.Item}
    >
      <img
        src={`${process.env.REACT_APP_URL}/api/common/image/${imgPath}`}
        alt={imgPath != null ? imgPath : "null.jpg"}
      />
      <div>{title}</div>
    </div>
  );
}
